/*
 * SundayBuilder · Screen 5 · Hand-Off
 * ---------------------------------------------------------------------
 * Two downloads and a quiet reset link. That's it.
 * =================================================================== */
import { Download, FileText } from "lucide-react";
import { track } from "../../lib/track";

export default function HandOff({ onNewPlan, plan }) {
  const download = (kind) => {
    track(`${kind.toUpperCase()} Export`, { product: "sundaybuilder" });
    window.print();
  };

  return (
    <div
      className="sb-screen"
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
      data-testid="sb-handoff"
    >
      <h1 style={{
        fontFamily: "var(--li-font-display)",
        color: "var(--li-text-primary)",
        fontSize: "2.5rem",
        fontWeight: 600,
        letterSpacing: "-0.01em",
        margin: "0 0 14px",
      }}>
        Take it into the parish.
      </h1>
      <p style={{
        fontFamily: "var(--li-font-body)",
        color: "var(--li-text-secondary)",
        fontSize: "1.125rem",
        margin: "0 0 56px",
      }}>
        Your dossier is prepared.
      </p>

      <div style={{ display: "flex", gap: 16 }}>
        <button className="sb-btn primary" onClick={() => download("pdf")} data-testid="sb-download-pdf">
          <Download size={16} strokeWidth={2.5} /> Download PDF
        </button>
        <button className="sb-btn primary" onClick={() => download("docx")} data-testid="sb-download-docx">
          <FileText size={16} strokeWidth={2.5} /> Download DOCX
        </button>
      </div>

      <button
        onClick={onNewPlan}
        data-testid="sb-prepare-another"
        style={{
          marginTop: 64,
          background: "transparent",
          border: "none",
          color: "var(--li-text-muted)",
          fontFamily: "var(--li-font-body)",
          fontSize: "0.9375rem",
          cursor: "pointer",
          textDecoration: "underline",
          textDecorationColor: "var(--li-border)",
          textUnderlineOffset: 3,
        }}
      >
        Prepare another Sunday →
      </button>

      {/* Printable hidden dossier for window.print() */}
      <div className="report-print-area" style={{ display: "none" }}>
        <h1>{plan?.title || "Worship Dossier"}</h1>
        {plan?.overview && <p>{plan.overview}</p>}
        {(plan?.services || []).map((s, i) => (
          <div key={i}>
            <h2>{s.name} · {s.occasion}</h2>
            {(s.hymns || []).map((h, j) => <div key={j}>{h.title || h.name}</div>)}
          </div>
        ))}
      </div>
    </div>
  );
}
